import { Panel } from '@wdg/blocks/panels-view-script';

document.querySelectorAll( '.aside-navigation' ).forEach( ( node ) => {
	new Panel( node, {
		interactiveClass: 'aside-navigation--interactive',
		toggle: '.aside-navigation__toggle',
		content: '.aside-navigation__items',
		openedClass: 'aside-navigation--opened',
	} );
} );
